import { INJECTION_SITES, siteColorFor } from "../lib/injections";
import { S } from "../theme";

function BodyDiagram({ view, logs, selectedSite, onSelectSite, hoverSite, onHoverSite, maxWidth = 240 }) {
  return (
    <div style={{ position: "relative", width: "100%", maxWidth, margin: "0 auto" }}>
      <svg viewBox="0 0 100 180" style={{ width: "100%", display: "block" }}>
        <g fill={S.surface2} stroke={S.border} strokeWidth="0.5">
          <circle cx="50" cy="12" r="9" />
          <rect x="35" y="22" width="30" height="42" rx="8" />
          <rect x="20" y="24" width="14" height="34" rx="7" />
          <rect x="66" y="24" width="14" height="34" rx="7" />
          <rect x="37" y="62" width="11" height="46" rx="5" />
          <rect x="52" y="62" width="11" height="46" rx="5" />
        </g>
        {INJECTION_SITES.filter(s => s.view === view).map(s => {
          const isSel = selectedSite === s.id;
          const isHov = hoverSite === s.id;
          // S.ink gives a high-contrast outline in both themes (near-black on
          // light, cream on dark) so the sites are always clearly visible.
          return (
            <circle key={s.id} cx={s.cx} cy={s.cy} r={isSel || isHov ? 7 : 6}
              fill={siteColorFor(logs, s.id)}
              stroke={S.ink} strokeWidth={isSel ? 2 : 1.2}
              style={{ cursor: onSelectSite ? "pointer" : "default" }}
              onClick={onSelectSite ? () => onSelectSite(s.id) : undefined}
              onMouseEnter={onHoverSite ? () => onHoverSite(s.id) : undefined}
              onMouseLeave={onHoverSite ? () => onHoverSite(null) : undefined} />
          );
        })}
      </svg>
      <div style={{ textAlign: "center", fontSize: "0.7rem", color: S.muted, fontWeight: 600, marginTop: 4, textTransform: "uppercase", letterSpacing: "0.08em" }}>{view}</div>
    </div>
  );
}

// Small list of a site's recent injections — shared by the picker and overview.

export { BodyDiagram };
